export default __webpack_public_path__ + "static/ricta2-bd034adb9ab4843965ae3e4574d44ae0.svg";